import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { req_edit_cslc_myparticipant } from "../../api";
import storageUtils from "../../utils/storageUtils";
import { Card, message } from "antd";
import FilePng from "./file-png";
//import FilePdf from "./file-pdf";

class MyParticipantFileAEditModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    participant: PropTypes.object,
    fileTarget: PropTypes.string,
  };

  state = {
    item: {
      Uid: "",
      AttachedfileA: "",
      AttachedfileB: "",
      AttachedfileC: "",
      condition: "",
    },
  };

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.init();
  }

  constructor(props) {
    super(props);

    this.get_png_file = React.createRef();
    this.get_pdf_file = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_edit_item = async (item) => {
    item.condition = this.props.fileTarget;
    const result = await req_edit_cslc_myparticipant(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success("上傳成功");
    } else {
      message.error(result.message);
    }
  };

  // 操作互動處理 //////////////////////////////////////////////

  init = () => {
    if (this.props.participant) {
      const item = this.props.participant;
      this.setState({ item });
    }
  };

  handleChange(event) {
    const { item } = this.state;
    //console.log(event)
    Object.keys(item).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        item[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ item });
  }

  handleSubmit(event) {
    event.preventDefault();
    const errors = [];

    const row = this.state.item;
    const png_file =
      this.get_png_file.current.output_files() === undefined
        ? ""
        : this.get_png_file.current.output_files();

    row.AttachedfileA = png_file === "" ? "" : png_file.url;

    if (errors.length === 0) {
      //console.log(row);
      this.api_edit_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    const { Uid, AttachedfileA } = this.state.item;
    //console.log(this.props.participant);
    const pngfileUrlPath = "/api/UploadFile/AddInsideContestFile";
    const pngFile =
      AttachedfileA === ""
        ? []
        : [
            {
              Uid: Uid,
              FileNewName: "全身立繪角色設計彩色稿",
              FileUrl: AttachedfileA,
            },
          ];
    return (
      <Card>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>
                <span className="text-danger">*</span>全身立繪(
                <span style={{ color: "blue" }}>
                  300dpi，A4(橫幅圖)，PNG格式
                </span>
                )
              </label>
              <FilePng
                ref={this.get_png_file}
                data_source={pngFile}
                api_url={pngfileUrlPath}
              ></FilePng>
            </div>
          </div>
          <div className="form-row">
            <input
              type="submit"
              value="送出"
              className="btn btn-primary btn-sm btn-block"
            />
          </div>
        </form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyParticipantFileAEditModal);
